import api from './api';

export const investmentService = {
  getAll: async () => {
    return api.get('/investments');
  },

  getById: async (investmentId) => {
    return api.get(`/investments/${investmentId}`);
  },

  create: async (data) => {
    return api.post('/investments', data);
  },

  update: async (investmentId, data) => {
    return api.put(`/investments/${investmentId}`, data);
  },

  delete: async (investmentId) => {
    return api.delete(`/investments/${investmentId}`);
  },

  addContribution: async (investmentId, data) => {
    return api.post(`/investments/${investmentId}/contributions`, data);
  },

  simulate: async (data) => {
    return api.post('/investments/simulate', data);
  },

  getSummary: async () => {
    return api.get('/investments/summary');
  },
};

export default investmentService;
